export default __webpack_public_path__ + "static/media/alert-triangle.96e16462.svg";